import * as React from 'react'

import { Box, Table, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

interface Props {
  label: string
}

const QuestionHeadCell = ({ label }: Props) => {
  const [open, toggle] = useToggle()

  return (
    <Table.HeadCell ellipsis width={360}>
      <Tooltip.Alt attachment="top center" label={label} open={open} toggle={toggle}>
        <Box
          style={{
            width: '320px',
          }}
        >
          <Text.Normal ellipsis size="200" weight="semibold">
            {label}
          </Text.Normal>
        </Box>
      </Tooltip.Alt>
    </Table.HeadCell>
  )
}

export default QuestionHeadCell
